export const AddNewCourse = ({onClick}) => {
    return (

        <div data-testid={"add-new-course-1"} onClick={onClick} className="file-container card-background-color" style={{ marginTop: "0.75rem" }}>
        <p className="standard-text semi-bold primary-600 small-standard-padding">+ Voeg nieuwe onderdeel toe</p>
        </div>
    )
}